import { ChatMessage as ChatMessageType } from "@/zapi-frontend/stores/chatStore";
import { reportErrorToSentry } from "@/zapi-frontend/utils/report-error-to-sentry";
export const createVersionLabel = (version: { content: string; timestamp: string }) =>
  `Version (${new Date(version.timestamp).toLocaleString()})`;

export const processMultiActionResponse = (content: string): ChatMessageType[] | null => {
  try {
    const parsed = JSON.parse(content);

    if (parsed.type === "multiAction" && Array.isArray(parsed.actions) && parsed.actions.length > 0) {
      return parsed.actions.map(
        (
          action: {
            type: string;
            content: string;
            notes?: string[];
            agentType?: string;
          },
          index: number
        ) => ({
          role: "assistant",
          content: JSON.stringify({
            type: action.type,
            content: action.content,
            notes: action.notes,
            agentType: action.agentType
          }),
          id: `action-${Date.now()}-${index}`
        })
      );
    }

    return null;
  } catch (e) {
    reportErrorToSentry(e as Error, "processMultiActionResponse", "error", {
      extra: {
        content
      }
    });
    return null;
  }
};
